import { render, staticRenderFns } from "./UserV2.vue?vue&type=template&id=1ba3b4ca&scoped=true&"
import script from "./UserV2.vue?vue&type=script&lang=js&"
export * from "./UserV2.vue?vue&type=script&lang=js&"
import style0 from "./UserV2.vue?vue&type=style&index=0&id=1ba3b4ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3b4ca",
  null
  
)

export default component.exports